/**
 * Spec ETT_Kgraph_Visualization_v0.0 §"Legend / class palette".
 *
 * Fixed 15-class palette so colour-coding stays stable across all KG viewer
 * mounts. Anything not in this map renders as the `other` colour.
 */

export const ETT_CLASS_COLORS: Record<string, string> = {
  Project: '#2563eb',
  EnergyProject: '#1d4ed8',
  ManufacturingProject: '#1e40af',

  Asset: '#10b981',
  EnergyAsset: '#059669',
  ManufacturingAsset: '#f59e0b',

  Organization: '#a855f7',
  ProjectCompany: '#9333ea',
  JointVenture: '#7e22ce',
  SPV: '#6b21a8',

  Agreement: '#ef4444',
  FinancingInstrument: '#ec4899',
  Policy: '#f97316',

  Technology: '#0ea5e9',
  Equipment: '#06b6d4',
  Geography: '#64748b',
  Event: '#facc15',
};

export const OTHER_CLASS_COLOR = '#94a3b8';

export function colorForClass(className: string | undefined): string {
  if (!className) return OTHER_CLASS_COLOR;
  // Accept both bare local names ("Project") and qualified IRIs ("ett:Project")
  const local = className.includes(':') ? className.split(':').pop() ?? '' : className;
  return ETT_CLASS_COLORS[local] ?? OTHER_CLASS_COLOR;
}

export const LEGEND_ORDER: string[] = [
  'Project',
  'EnergyProject',
  'ManufacturingProject',
  'Asset',
  'EnergyAsset',
  'ManufacturingAsset',
  'Organization',
  'ProjectCompany',
  'Agreement',
  'FinancingInstrument',
  'Policy',
  'Technology',
  'Equipment',
  'Geography',
  'Event',
];
